export enum Paths {
  Landing = "landing",
  Home = "home",
  CatalogManagement = "catalog-management",
  CatalogManager = "catalog-manager",
  CreateCatalog = "create-catalog",
  EditCatalog = "edit-catalog",
  ReviewCatalog = "review",
  CatalogDetails = "catalog",
  SubscribeSolution = "subscribe-solution",
  PackageManager = "package-manager",
  PackageManagerViewPackages = "packages",
  PackageDeployments = "deployments",
  PackageInstall = "package-install",
  CatalogTypeManager = "catalog-type-manager",
  CdvManager = "cdv-manager",
  CreateCatalogType = "create",
  EditCatalogType = "edit-catalog-type",
  Administer = "administer",
  Subscription = "subscription",
  SettingsMenu = "settings-menu",
  Settings = "settings",
  ExportList = "token-manager",
  MyProfile = "my-profile",
  SupportCenter = "support-center",
  Dashboard = "dashboard",
}

interface IRouteConfig {
  path: string;
  label: string;
  children?: IRouteConfig[];
}

const routes: IRouteConfig[] = [
  {
    path: `/${Paths.Home}`,
    label: "hub.sidebar.home",
  },
  {
    path: `/${Paths.CatalogManager}`,
    label: "hub.header.catalog",
    children: [
      {
        path: Paths.CreateCatalog,
        label: "hub.routes.create_catalog",
      },
      {
        path: Paths.EditCatalog,
        label: "hub.routes.edit_catalog",
      },
      {
        path: Paths.CatalogDetails,
        label: "hub.routes.catalog_details",
      },
      {
        path: Paths.ReviewCatalog,
        label: "hub.routes.review_catalog",
      },
      {
        path: Paths.SubscribeSolution,
        label: "hub.routes.subscribe_solution",
      },
    ],
  },
  {
    path: `/${Paths.CdvManager}`,
    label: "hub.routes.cdv_manager",
  },
  {
    path: `/${Paths.CatalogTypeManager}`,
    label: "hub.breadcrumb.catalog_type",
    children: [
      {
        path: Paths.CreateCatalogType,
        label: "hub.routes.create_catalog_type",
      },
      {
        path: Paths.EditCatalogType,
        label: "hub.routes.edit_catalog_type",
      },
    ],
  },
  {
    path: `/${Paths.Administer}`,
    label: "hub.sidebar.administer",
  },
  {
    path: `/${Paths.Subscription}`,
    label: "hub.home.solution_subscription_status",
  },
  {
    path: `/${Paths.ExportList}`,
    label: "hub.sidebar.token_manager",
  },
  {
    path: `/${Paths.PackageManager}`,
    label: "hub.sidebar.package_manager",
  },
  {
    path: `/${Paths.Settings}`,
    label: "hub.sidebar.settings",
  },
  {
    path: `/${Paths.MyProfile}`,
    label: "hub.sidebar.my_profile",
  },
  {
    path: `/${Paths.SupportCenter}`,
    label: "hub.routes.support_center",
  },
  {
    path: `/${Paths.Dashboard}`,
    label: "hub.sidebar.dashboard",
  },
];

export function pathToEditCatalog(catalogId: number, version: string): string {
  return `/${Paths.CatalogManager}/${Paths.EditCatalog}?catalogId=${catalogId}&version=${version}`;
}

export const routeLabels: Record<string, string> = routes.reduce(
  (acc, route) => {
    const segment = route.path.replace("/", "") || "";
    if (route.label) acc[segment] = route.label;

    if (route.children) {
      route.children.forEach((child) => {
        if (child.label) acc[child.path] = child.label;
      });
    }

    return acc;
  },
  {} as Record<string, string>,
);
